"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Tabs_shared_exports = {};
__export(Tabs_shared_exports, {
  useTabsWithChildren: () => useTabsWithChildren,
  useTabsWithTriggers: () => useTabsWithTriggers
});
module.exports = __toCommonJS(Tabs_shared_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_native = require("@react-navigation/native");
var import_react = require("react");
var import_hooks = require("../hooks");
var import_href = require("../link/href");
var import_Route = require("../router/Route");
var import_url = require("../utils/url");
var import_Navigator = require("../views/Navigator");
var import_common = require("./common");
var import_TabContext = require("./TabContext");
var import_TabList = require("./TabList");
var import_TabRouter = require("./TabRouter");
var import_TabSlot = require("./TabSlot");
var import_TabTrigger = require("./TabTrigger");
var import_useComponent = require("./useComponent");
function useTabsWithChildren(options) {
  var { children, ...rest } = options;
  return useTabsWithTriggers({
    triggers: parseTriggersFromChildren(children),
    ...rest
  });
}
function useTabsWithTriggers(options) {
  var { triggers, ...rest } = options;
  var parentTriggerMap = (0, import_react.use)(import_TabContext.TabTriggerMapContext);
  var routeNode = (0, import_Route.useRouteNode)();
  var contextKey = (0, import_Route.useContextKey)();
  var linking = (0, import_react.use)(import_native.LinkingContext).options;
  var routeInfo = (0, import_hooks.useRouteInfo)();
  if (!routeNode || !linking) {
    throw new Error("No RouteNode. This is likely a bug in one router.");
  }
  var { children, triggerMap } = (0, import_common.triggersToScreens)(triggers, routeNode, linking, routeNode.initialRouteName, parentTriggerMap, routeInfo, contextKey);
  var navigatorContext = (0, import_native.useNavigationBuilder)(import_TabRouter.ExpoTabRouter, {
    children,
    ...rest,
    triggerMap,
    initialRouteName: routeNode.initialRouteName
  });
  var { state, descriptors, navigation, render } = navigatorContext;
  var descriptorsRef = (0, import_react.useRef)(descriptors);
  descriptorsRef.current = descriptors;
  var navigatorContextValue = (0, import_react.useMemo)(function() {
    return {
      state,
      navigation,
      contextKey,
      router: import_TabRouter.ExpoTabRouter,
      descriptorsRef
    };
  }, [
    state,
    navigation,
    contextKey
  ]);
  var NavigationContent = (0, import_useComponent.useComponent)(function(children2) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_TabContext.TabTriggerMapContext.Provider, {
      value: triggerMap,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Navigator.NavigatorContext.Provider, {
        value: navigatorContextValue,
        children: render(children2)
      })
    });
  });
  return {
    state,
    descriptors,
    navigation,
    NavigationContent
  };
}
function parseTriggersFromChildren(children) {
  var screenTriggers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], isInTabList = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  import_react.Children.forEach(children, function(child) {
    if (!child || !/* @__PURE__ */ (0, import_react.isValidElement)(child) || (0, import_TabSlot.isTabSlot)(child)) return;
    if (isFragment(child) && typeof child.props.children !== "function") {
      return parseTriggersFromChildren(child.props.children, screenTriggers, isInTabList || (0, import_TabList.isTabList)(child));
    }
    if ((0, import_TabList.isTabList)(child) && typeof child.props.children !== "function") {
      var _$children = child.props.children;
      if (child.props.asChild && /* @__PURE__ */ (0, import_react.isValidElement)(_$children) && _$children.props && typeof _$children.props === "object" && "children" in _$children.props) {
        _$children = _$children.props.children;
      }
      return parseTriggersFromChildren(_$children, screenTriggers, isInTabList || (0, import_TabList.isTabList)(child));
    }
    if (!isInTabList || !(0, import_TabTrigger.isTabTrigger)(child)) return;
    var { href, name } = child.props;
    if (!href) {
      if (process.env.NODE_ENV === "development") {
        console.warn(`<TabTrigger name={${name}}> does not have a 'href' prop. TabTriggers within a <TabList /> are required to have an href.`);
      }
      return;
    }
    var resolvedHref = (0, import_href.resolveHref)(href);
    if ((0, import_url.shouldLinkExternally)(resolvedHref)) {
      screenTriggers.push({
        type: "external",
        name,
        href: resolvedHref
      });
      return;
    }
    if (!name) {
      if (process.env.NODE_ENV === "development") {
        console.warn(`<TabTrigger> does not have a 'name' prop. TabTriggers within a <TabList /> are required to have a name.`);
      }
      return;
    }
    screenTriggers.push({
      type: "internal",
      href: resolvedHref,
      name
    });
  });
  return screenTriggers;
}
function isFragment(child) {
  return child.type === import_react.Fragment;
}
//# sourceMappingURL=Tabs.shared.js.map
